import {Component, Input, OnChanges, ChangeDetectionStrategy} from '@angular/core';

// Models
import { PaymentTerm } from '../models/payment-term.model';

import { OrdinalDatePipe } from '../../shared/pipes/ordinal-date.pipe';
import { SeFeThemesLoader } from 'se-fe-themes';

@Component({
  selector: 'app-payment-term-summary',
  templateUrl: './payment-term-summary.component.html',
  providers: [ OrdinalDatePipe ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaymentTermSummaryComponent implements OnChanges {
  public detailParams: Object;
  public installmentWindow: string;

  @Input() paymentTerm: PaymentTerm;

  constructor(private ordinal: OrdinalDatePipe) {
    SeFeThemesLoader.load({
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com'
    });
   }

  ngOnChanges(): void {
    this.detailParams = {
      count: this.paymentTerm.payment_term_strategy.installment_count,
      interval: this.paymentTerm.payment_term_strategy.interval,
      ordinalDate: this.ordinal.transform(this.paymentTerm.payment_term_strategy.day_of_month),
      percentageType: this.paymentTerm.payment_term_strategy.percentage_type
    };
    this.installmentWindow = this.paymentTerm.payment_term_strategy.installment_window;
  }
}
